import React from 'react';

// Wrapper around Bootstrap Icons (static font in public/assets/css/bootstrap-icons, v1.11.3).
// Outline glyphs are the house style, so "-fill" names are mapped to their outline twin.

export const ICON_SIZES = { sm: 16, md: 20, lg: 24 }; // inline/table actions, buttons/menus, headers/cards

// "-fill" glyphs that have no outline twin in v1.11.3
const OUTLINE_OVERRIDES = { "person-lines-fill": "person-vcard" };

// Accepts "airplane", "bi-airplane-fill" or "bi bi-airplane-fill" (menu m_icon values) and returns "airplane"
export const toOutlineIcon = (value, fallback = "app") => {
  const tokens = String(value || "").trim().split(/\s+/).filter(Boolean);
  const token = tokens.find((t) => t.startsWith("bi-")) || tokens.find((t) => t !== "bi");
  if (!token) return fallback;
  const name = token.replace(/^bi-/, "");
  return OUTLINE_OVERRIDES[name] || name.replace(/-fill$/, "");
};

// size: "sm" | "md" | "lg" or a pixel number. Pass `label` only when the icon carries meaning on its own.
const Icon = ({ name, size = "md", color = "currentColor", label, className = "", style }) => {
  const px = ICON_SIZES[size] || size;
  return (
    <i
      className={`bi bi-${toOutlineIcon(name)} ${className}`.trim()}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
        width: px, height: px, fontSize: px, lineHeight: 1, color, ...style
      }}
    />
  );
};

export default Icon;
